
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4c1f1afe&scoped=true!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./volumeIndicator.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4c1f1afe!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./volumeIndicator.vue"),
  /* scopeId */
  "data-v-4c1f1afe",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/liveDiscussion/components/volumeIndicator.vue
// module id = 235
// module chunks = 61